import { InjectionToken } from '@angular/core';

export const AppConfigToken = new InjectionToken('IAppConfig');
export const OAuthConfigToken = new InjectionToken('IOAuthConfig');
export const BaseURI = new InjectionToken('BaseURI');
export const APIBaseURI = new InjectionToken('APIBaseURI');
